import { ComponentType } from 'react';
import { ModuleTypeEnum } from '../../dtos/participantdata/scanmodule/module-type.enum';
import AttendanceActionSelector from './AttendanceActionSelector';

/**
 * Props for a pre-scan action selector component.
 * The component receives the current action value and a callback to update it.
 */
export interface ActionSelectorProps {
    value: string | null;
    onChange: (action: string | null) => void;
}

/**
 * Registry entry for a scan module type.
 * Each module type can optionally define a pre-scan action selector component.
 */
interface ModuleRegistryEntry {
    /** Component rendered before scanning to select an action (e.g. checkin/checkout) */
    ActionSelector: ComponentType<ActionSelectorProps> | null;
    /** Human-readable label for the module type */
    label: string;
}

/**
 * Component registry mapping ModuleTypeEnum to UI configuration.
 * Used by ticket-scan.tsx to render module-specific action selectors
 * and by module-select.tsx to display type labels.
 */
const moduleRegistry: Record<ModuleTypeEnum, ModuleRegistryEntry> = {
    [ModuleTypeEnum.ATTENDANCE]: {
        ActionSelector: AttendanceActionSelector,
        label: 'Attendance',
    },
    [ModuleTypeEnum.EVENTLIMIT]: {
        ActionSelector: null,
        label: 'Event Limit',
    },
    [ModuleTypeEnum.DAILYLIMIT]: {
        ActionSelector: null,
        label: 'Daily Limit',
    },
};

export const getActionSelector = (
    moduleType: ModuleTypeEnum,
): ComponentType<ActionSelectorProps> | null => {
    return moduleRegistry[moduleType]?.ActionSelector ?? null;
};

export const getModuleTypeLabel = (moduleType: ModuleTypeEnum): string => {
    return moduleRegistry[moduleType]?.label ?? moduleType;
};
